// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {Text, Separator} from 'trpc-react-native-ui';
import {FullButton, GradientPage, Icon} from '../../../components/common';
import I18n from '../../../lib/i18n';
import WizzeeLog from '../../../lib/wizzeeLog';

const styles = StyleSheet.create({
  scrollViewContainer: {
    display: 'flex',
    margin: 0,
    marginTop: 50,
  },
  parentContainer: {
    display: 'flex',
    marginLeft: 25,
    marginTop: 40,
    marginRight: 25,
    marginBottom: 25,
  },
  button: {
    alignSelf: 'center',
    marginTop: 20,
    marginBottom: 20,
    paddingHorizontal: 20,
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '500',
  },
  icon: {
    alignSelf: 'center',
    marginBottom: 20,
  },
  shortTitle: {
    alignSelf: 'center',
    color: 'red',
    fontSize: 23,
    marginBottom: 50,
  },
  description: {
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    color: 'blue',
    fontSize: 18,
  },
  legalMention: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    color: 'gray',
    fontSize: 13,
    marginTop: 60,
    marginBottom: 40,
  },
});

type Props = {
  setCurrentVoucherDetails: Function,
  goToChangePlan: Function,
  comeFrom: string,
  isLineOFF: Boolean,
};

class VoucherDetails extends Component<Props> {
  render() {
    const {
      route,
      setCurrentVoucherDetails,
      goToPreviousScreen,
      comeFrom,
      isLineOFF,
    } = this.props;

    WizzeeLog.log('VoucherDetails - comeFrom: ', comeFrom);

    if (!route.params) {
      return null;
    }

    const voucherDetails = route.params.voucherDetails;
    const disabledButton = route.params.disabledButton ?? false;

    const onPressGoToNextPage = () => {
      setCurrentVoucherDetails(voucherDetails);
      goToPreviousScreen(comeFrom, isLineOFF, voucherDetails);
    };
    
    const edgesByOs = ['top', 'left', 'right'];

    return (
      <GradientPage iosEdges={edgesByOs} androidEdges={edgesByOs}>
        <ScrollView style={styles.scrollViewContainer}>
          <View style={styles.parentContainer}>
            <Icon
              style={styles.icon}
              name={I18n.t(
                `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucherDetails.labelCode}.picto`,
              )}
              size={80}
              color={'blue'}
            />
            <Text style={styles.shortTitle}>
              {I18n.t(
                `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucherDetails.labelCode}.label`,
              )}
            </Text>
            <Text style={styles.description}>
              {I18n.t(
                `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucherDetails.labelCode}.longDesc`,
              )}
            </Text>
            <Text style={styles.legalMention}>
              {I18n.t(
                `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucherDetails.labelCode}.terms`,
              )}
            </Text>
          </View>
        </ScrollView>
        <Separator direction="horizontal" thickness={2} />
        <FullButton
          text={I18n.t(
            `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${voucherDetails.labelCode}.buttonText`,
          )}
          onPress={onPressGoToNextPage}
          style={styles.button}
          textStyle={styles.buttonText}
          disabled={disabledButton}
        />
      </GradientPage>
    );
  }
}

export default VoucherDetails;
